import { Component } from '@angular/core';

@Component({
    selector: 'app-header-bare',
    templateUrl: './header-bare.component.html',
    styleUrls: ['./header-bare.component.sass']
})
export class HeaderBareComponent {}
